// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"0467eb6f3c196e2a","3319":"fa519fbb71438a95","5405":"860236b70dfb416e"}[chunkId] + ".css";
};